import React from 'react';
import { Link } from 'react-router-dom';

function HeroSection() {
  return (
    <div className="hero dark-section parallaxie">
      <div className="container">
        <div className="row align-items-end">

          <div className="col-lg-12">
          <div className="page-flash-header">
            <h1 className="text-anime-style-2" data-cursor="-opaque">Your truck booking starts @ <span>Rs.200</span></h1>

          </div>
          </div>

          
          <div className="col-lg-12">
            <div className="hero-content-box">
              <div className="hero-content">
                <div className="section-title">
                  <h1 className="text-anime-style-2" data-cursor="-opaque">Welcome to <span>Hello Truck!</span></h1>
                </div>
              </div>

              <div className="hero-customer-box">
                <div className="hero-customer-content wow fadeInUp">
                  <p>Professional truck booking & goods transport services in Coimbatore and Tiruppur. Whether you need mini trucks, Kutty Yaanai (Tata Ace), 407, Bolero, tempo, or lorries for home shifting, office relocation, or commercial transport, we're here to make your life easier. Book your truck today!</p>
                </div>

                <div className="satisfy-customer-box">
                  <div className="satisfy-customer-images">
                    <div className="satisfy-customer-image">
                      <figure>
                        <img src="/hellotruck-web-images/satisfy-customer-1.jpg" alt="Satisfied Customer 1" />
                      </figure>
                    </div>
                    <div className="satisfy-customer-image">
                      <figure>
                        <img src="/hellotruck-web-images/satisfy-customer-2.jpg" alt="Satisfied Customer 2" />
                      </figure>
                    </div>
                    <div className="satisfy-customer-image">
                      <figure>
                        <img src="/hellotruck-web-images/satisfy-customer-3.jpg" alt="Satisfied Customer 3" />
                      </figure>
                    </div>
                  </div>

                  <div className="satisfy-customer-content">
                    <h3>Customer Satisfied</h3>
                    <p><span className="counter">4.8</span> (200+ Reviews)</p>
                  </div>
                </div>

                <div className="hero-btn wow fadeInUp" data-wow-delay="0.2s">
                  <a href="https://digital.hellotruck.in/login/user-login" target="_blank" rel="noopener noreferrer" className="btn-default btn-highlighted">Book Now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HeroSection;